module.exports = __webpack_public_path__ + "img/jednotlivec.d0ffb53e.svg";